import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRouteLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 5H15.5C17.433 5 19 6.567 19 8.5C19 10.433 17.433 12 15.5 12H8.5C6.567 12 5 13.567 5 15.5C5 17.433 6.567 19 8.5 19H13M8 5C8 6.10457 7.10457 7 6 7C4.89543 7 4 6.10457 4 5C4 3.89543 4.89543 3 6 3C7.10457 3 8 3.89543 8 5ZM20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19C16 17.8954 16.8954 17 18 17C19.1046 17 20 17.8954 20 19Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgRouteLine;
